// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7bae7655","513":"eec7d256"}[chunkId] + ".chunk.js";
};